<template>


  <div class="ma-6 pa-6 elevation-1">
    <div class="ma-3">

    </div>
    <v-img class="pa-10 ma-10" contain :aspect-ratio="16 / 112" max-width="160" max-height="90"
      src="./../assets/nuage.png"></v-img>
    <br>
    <div class="text-h2">
      The vending machine best friend
    </div>

    <br>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="name" :counter="25" :rules="nameRules" label="Username" required></v-text-field>

      <v-text-field type="password" v-model="password" :rules="passwordRules" label="Password" required></v-text-field>



      <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">
        Validate
      </v-btn>

      <v-btn color="error" class="mr-4" @click="reset">
        Reset
      </v-btn>

    </v-form>
    <v-card class="text-caption d-flex justify-end mb-6" flat tile>V0.9.8</v-card>

  </div>

</template>


<script>
import { store } from "@/models/Store.js";

export default {
  data: () => ({
    store: store,
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 25) || 'Name must be less than 25 characters',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Pasword is required',
    ]



  }),

  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.password.length === 0) return;

      this.$http.post(process.env.VUE_APP_API_EXT_URL.split('API_EXT')[0] + 'auth/API_EXT/login', {
        username: this.name,
        pwd: this.password
      })
        .then(
          // ---- succès HTTP ----
          response => {
            localStorage.setItem('jwt', response.data.token);
            localStorage.setItem('idUser', response.data._id);

            this.store.setIsCurrentUserAdmin(response.data.isAdmin);
            this.store.setCurrentUsername(this.name);

            const target = this.$route.params.nextUrl || '/';
            this.$router.push(target).catch(err => {
              // vue-router 3.4 renvoie une promesse qui rejette si la navigation
              // est redirigée ou annulée — sans ce catch, l'erreur reste invisible
              console.warn('Navigation après login :', err && err.message);
            });
          },
          // ---- échec HTTP uniquement ----
          error => {
            console.error('Login failed:', error);
            const status = error.response ? error.response.status : null;
            alert(status
              ? `Authentification failed !\nstatus : ${status}`
              : `Impossible de contacter le serveur : ${error.message}`);
          }
        )
        .catch(err => {
          // erreurs survenues DANS le bloc de succès → enfin visibles
          console.error('Erreur après login (post-traitement) :', err);
          alert('Connexion réussie mais erreur applicative : ' + err.message);
        });
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
}
</script>
